import React from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
import dt from "dayjs";

const DATE_FORMAT = "YYYY-MM-DD";

const DateRangePicker = ({ value, onChange, disabled = false, allowClear = false }) => (
  <RangePicker
    value={value ? value.split("--").map(ds => dt(ds)) : null}
    format={DATE_FORMAT}
    allowEmpty={[true, true]}
    presets={[
      { label: "Today", value: [dt(), dt()] },
      { label: "This Week", value: [dt().startOf("week"), dt().endOf("week")] },
      { label: "Last Week", value: [dt().subtract(1, "week").startOf("week"), dt().subtract(1, "week").endOf("week")] },
      { label: "This Month", value: [dt().startOf("month"), dt().endOf("month")] },
      { label: "Last Month", value: [dt().subtract(1, "month").startOf("month"), dt().subtract(1, "month").endOf("month")] },
      { label: "This Year", value: [dt().startOf("year"), dt().endOf("year")] },
      { label: "Past 5 Years", value: [dt().subtract(5, "year").startOf("year"), dt()] }
    ]}
    onChange={(dates, dateStrings) => onChange(dates && dates.length > 0 ? dateStrings.join("--") : undefined)}
    disabled={disabled}
    allowClear={allowClear}
  />
);

DateRangePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  allowClear: PropTypes.bool
};

export default DateRangePicker;
